import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import {
    getConfItem,
    getLabel,
    getQuotationsTitle
} from '../../../conf/conf';

import { connect } from "react-redux";
import appStore from '../../../redux/store/appStore';
import {
    updateGui,
    updateQuotations,
    updateQuotationsTotal,
    updateQuotationsOption,
    updateQuotationsSelectedQuotation,
    updateQuotationsSelectedImpianto
} from '../../../redux/actions/actions';

import {
    config as httpClientConfig,
    quotationsGet as httpClientQuotationsGet
} from '../../../libs/http-client';
import { quotationsGetRequestData } from '../../../libs/http-client-dataManager';

import Header from '../../Header';
import Loading from '../../Loading';
import PageQuotationsDestkop from './PageQuotationsDesktop';

import { gaTrackPage } from '../../../helpers/google-analytics-helper';
import {
    urlRewriteWithSearchStringFromState,
    currentUrlAddSearchString
} from '../../../helpers/browser-navigation-helper';
import { mapImageUrlInReactComponent, mapImageUrlResize } from '../../../helpers/google-map-helper';
import { pageComponentCssClass } from '../../../helpers/components-helper';
import {
    format,
    priceStringToFloat,
    priceStringFormat
} from '../../../helpers/currency-helper';

import {
    quotationTypeFromOptionId,
    kwhToQuotationType
} from '../../../helpers/quotations-helper';
import { getItem } from '../../../helpers/object-helper';

import './PageQuotations.css';

const mapStateToProps = state => {
    return {
        gui: state.gui,
        map: state.map
    };
};

const imgLabelsDummyUrl = '/images/quotations-labels-dummy.jpg';

const quotationsConfig = {
    sistemaAccumulo: {
        label: '',
        /**
         * Adds an hardcoded details string to each storage system label (this is a patch for the Web API /quote endpoint does not send the details information)
         * @param {String} value 
         * @param {Object} options 
         * @returns React JSX
         */
        valueGuiFn: (value, options) => {
            const details = (options.quotationType === 'kwh5') ?
                'In linea con le tue condizioni attuali di consumo' :
                'Perfetto per massimizzare i valori di risparmio attuali e futuri';
            return (
                <div>
                    <div>{ value }</div>
                    <div>{ details }</div>
                </div>
            );
        }
        
    },
    dimensioneSistemaSolare: {
        label: 'Dimensione impianto fotovoltaico esistente'
    },
    tipoBatteria: {
        label: 'Batteria',
        info: `<div class="slc-data-label-info-content__head">Batteria</div>
        <div class="slc-data-label-info-content__body">La soluzione tecnica proposta e la relativa capacità di accumulo saranno la migliore sintesi tra qualità, prezzo, performance, garanzia di prodotto e disponibilità di mercato.</div>`
    },
    sistemaAccumuloConsigliato: {
        label: 'Capacità di Accumulo consigliata',
        info: `<div class="slc-data-label-info-content__head">Capacità di Accumulo consigliata</div>
        <div class="slc-data-label-info-content__body">Accumulare l’energia solare prodotta dal tuo impianto e non autoconsumata è un’ottima soluzione per ridurre i costi della domanda di energia verso la rete e un gran passo verso l’indipendenza energetica.<br />Se ben bilanciato il rapporto tra potenza impianto fotovoltaico, la capacità di accumulo della batteria e le tue abitudini di consumo si possono raggiungere valori di risparmio fino al 70% della bolletta elettrica.</div>`
    },
    garanziaSistemaAccumulo:{
        label:'Garanzia Batteria',
        values: {
            kwh5: '10 anni',
            kwh10: '10 anni'
        }
    },
    totale:{
        label:'Totale (IVA 10% inclusa)',
        valueGuiFn: (value) => priceStringFormat(value)
    },
    totaleCessioneCredito: {
        label:'Totale con detrazione fiscale 50%',
        info: `<div class="slc-data-label-info-content__head">Totale con detrazione fiscale 50%</div>
        <div class="slc-data-label-info-content__body">Optando per la CESSIONE DEL CREDITO verso banche, assicurazioni o imprese, puoi utilizzare immediatamente la detrazione fiscale per la realizzazione di un intervento di riqualificazione energetica pagando soltanto la quota parte di spesa non incentivabile.</div>`
    },        
    scegli:{
        label: '',
        values: {
            kwh5: null,
            kwh10: null
        }
    }
};

class PageQuotations extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            mapStaticImageUrl: null,
            loading: false,
            config: quotationsConfig,
            data: null,         // quotationsResponse.quotations
            totals: null        // will store the totals table, cloning it quotationsResponse.quotations.totale
        };
    }

    componentDidMount() {

        // update current url with search string
        currentUrlAddSearchString();

        // dispatch current step title
        appStore.dispatch(updateGui({
            currentStepTitle: getQuotationsTitle()
        }));

        // set map static image url
        this.setMapStaticImageUrl();

        // request quotations to http web api
        httpClientConfig({
            baseUrl: getConfItem('api.' + process.env.NODE_ENV + '.baseUrl')
        });
        this.fetchQuotations();

        // Google Analytics track page
        gaTrackPage();
    }

    /**                                                                              Redirect
     * ======================================================================================
     */

    /**
     * Navigates back to Wizard Step 4
     */
    navigateBack() {
        this.setState((state, props) => ({
            redirect: urlRewriteWithSearchStringFromState('wizard/step4')
        }));
    }

    /**
     * Navigates back to Wizard Step 1
     */
    navigateToWizard() {
        this.setState((state, props) => ({
            redirect: urlRewriteWithSearchStringFromState('wizard/step1')
        }));
    }


    /**                                                                                  Data
     * ======================================================================================
     */

    /**
     * Triggers quotations fetch from the SolarConfig API
     */
    fetchQuotations() {
        this.setState((state, props) => ({
            loading: true
        }));
        httpClientQuotationsGet(quotationsGetRequestData())
            /**
             * @param {Object} response
             *  .config (axios config)
             *  .data (actual data)
             *  .headers (http headers)
             *  .request (xmlhttp)
             */
            .then(function(response) {
                ////console.log('httpClientQuotationsGet(), response ', response);
                this.onFetchQuotationsResponse(response.data);
            }.bind(this));
    }

    /**
     * Fetch quotations response handler
     * @param {Object} response 
     */
    onFetchQuotationsResponse(response) {

        ////console.log('PageQuotations.onFetchQuotationsResponse()');

        // switch loading to false
    
        this.setState((state, props) => ({
            loading: false
        }));

        // read response data
        const uuid = response.uuid;
        const quotations = response.quotations;

        ////console.log('RESPONSE = ', response);

        // update state (this.state.valutazione, this.state.data) with response data

        this.setState((state, props) => {
            return {
                data: {
                    ...response.quotations,
                    totaleCessioneCredito: {
                        kwh5: this.getTotaleCessioneCreditoFromTotal(response.quotations.totale.kwh5),
                        kwh10: this.getTotaleCessioneCreditoFromTotal(response.quotations.totale.kwh10)
                    }
                },
                totals: {...response.quotations.totale}
            };
        });

        // update application store quotations (.quotations) with response data
        // info
        // ...for options, we need a boolean indicating if the option has been choosen, not the option cost
        // ...this is why we assign false here and not the value (the cost) stored in the response
        appStore.dispatch(updateQuotations({
            quotations: {
                uuid: uuid,
                //valutazione: valutazione,
                kwh5: {
                    total: quotations.totale.kwh5
                },
                kwh10: {
                    total: quotations.totale.kwh10
                }
            }
        }));

    }

    /**
     * Returns totalCessioneCredito from total
     * Must divide total/2
     * Converts total string to float (priceStringToFloat), executes the division and reconverts the result to string again (format)
     * @param {String} total
     *  Sample
     *      '7.381,9'
     * @return {Float}
     *  Sample
     *      3690.95
     */
    getTotaleCessioneCreditoFromTotal(total) {
        return format(priceStringToFloat(total) / 2);
    }

    /**
     * Updates quotations totale in Component state (this.state.data.totale)
     * @param {String} quotationType 
     *  Range
     *      ['basic'|'plus']
     * @param {String} Number 
     */
    updateStateTotale(quotationType, value) {
        this.setState((state, props) => {

            const updateObj = {
                data: {
                    totale:{}
                }
            };
            updateObj.data.totale[quotationType] = value;

            const updateTotale = {
                ...state.data.totale,
                ...updateObj.data.totale
            };

            return {
                ...state,
                data: {
                    ...state.data,
                    totale: updateTotale
                }
            };

        });
    }

    /**
     * Updates quotations totale and options in application store
     * @param {String} quotationType
     *  Range
     *      ['basic'|'plus']
     * @param {Number} totalValue
     *  Sample
     *      12901.39
     * @param {String} optionId
     *  Sample
     *      'accumulatoreProposto'
     * @param {Boolean} optionValue 
     */
    updateStoreOptionsAndTotale(quotationType, totalValue, optionId, optionValue) {

        appStore.dispatch(updateQuotationsTotal({
            quotationType: quotationType,
            totalValue: totalValue
        })); 

        appStore.dispatch(updateQuotationsOption({
            quotationType: quotationType,
            optionId: optionId,
            optionValue: optionValue
        })); 

    }

    /**
     * Updates quotations selected quotation in application store (.quotations.selectedQuotation)
     * @param {String} quotationType
     *  Range
     *      ['basic'|'plus']
     */
    updateStoreSelectedQuotation(quotationType) {
        appStore.dispatch(updateQuotationsSelectedQuotation({
            quotationType: quotationType
        }));        
    }

    /**
     * Updates quotations selected impianto in application store (.quotations.selectedImpianto)
     * @param {String} impianto
     *  Range
     *      ['basic'|'basic-accumulo'|'plus'|'plus-accumulo'|'plus-s'|'plus-s-accumulo']
     */
    updateStoreSelectedImpianto(impianto) {
        appStore.dispatch(updateQuotationsSelectedImpianto({
            impianto: impianto
        }));        
    }

    /**
     * Sets this.state.mapStaticImageUrl driven by the application store
     */
    setMapStaticImageUrl() {
        const imageSize = getConfItem('gui.map.mapStaticImage.sizeInQuotationsComponent');
        const mapImageUrl = this.props.map.staticImageUrl;
        const mapImageUrlResized = mapImageUrlResize(mapImageUrl, imageSize);        
        this.setState(() => ({
            mapStaticImageUrl: mapImageUrlResized
        }));
    }

    /**                                                                                Events
     * ======================================================================================
     */

    onQuoteChooseButtonClick(evt) {

        const selectedClassName = 'slc-button-quotation-selected';

        // is the checkbox selected?
        ////console.log(evt.target);
        const selected = evt.target.classList.contains(selectedClassName);//evt.target.checked;

        // parent element to read important infos from parent element attributes
        const parent = evt.target.parentElement;

        // id of the checkbox (containes both the quotation type and the option name)
        const dataOptionId = parent.getAttribute('data-option-id');                         // Sample: 'ottimizzatori-plus'

        // the quotation type ('basic'|'plus')
        const quotationType = quotationTypeFromOptionId(dataOptionId);                      // sample: 'plus'
        
        // unselect if already selected
        if (selected) {

            // update selected quotation model and gui
            evt.target.classList.remove(selectedClassName);

            // update the application store selected quotation
            const selectedQuotation = null;
            this.updateStoreSelectedQuotation(selectedQuotation);

            // update the Gui quotation selector choose buttons
            // this.quotationSelectorCheckboxesGui(dataOptionId, selected); FOR CHECKBOXES, MUST BE IMPLEMENTED FOR CHOOSE BUTTONS
            // TODO
            this.quotationSelectorChooseButtonsGui(dataOptionId, false, selectedClassName);

            // update the cessioneDelCredito values gui, depending on the selected quotation type
            this.cessioneDelCreditoValuesGui(false, quotationType);

            // update form emphasize gui
            this.formEmphasizeManageGui(selectedQuotation);

        // select if not selected
        } else {

            // update selected quotation model and gui
            evt.target.classList.add(selectedClassName);

            // update the application store selected quotation
            const selectedQuotation = quotationType;
            this.updateStoreSelectedQuotation(selectedQuotation);

            // update the Gui quotation selector choose buttons
            // this.quotationSelectorCheckboxesGui(dataOptionId, selected); FOR CHECKBOXES, MUST BE IMPLEMENTED FOR CHOOSE BUTTONS
            // TODO
            this.quotationSelectorChooseButtonsGui(dataOptionId, true, selectedClassName);

            // update the cessioneDelCredito values gui, depending on the selected quotation type
            this.cessioneDelCreditoValuesGui(true, quotationType);

            // update form emphasize gui
            this.formEmphasizeManageGui(selectedQuotation);
        }

        // update the application store selected impianto
        // get the selected quotation/column (basic or plus?)
        const selectedQuotation = getItem('quotations.selectedQuotation', appStore.getState());
        // if no quotation is selected, selected impianto is null also
        if (selectedQuotation === null) {
            this.updateStoreSelectedImpianto(null);
        // if some quotation is selected
        } else {
            // if the user interacted option checkbox belongs to the selected quotation/column, calculate selected impianto based on the user choices
            if (quotationType === selectedQuotation) {
                this.updateStoreSelectedImpianto(quotationType);
            }
        }
    }
    
    /**
     * Click event handler for the full page
     * Clicking anywhere in the page causes deleting the currently shown label info popup, if any
     * This function is passed down to child components as a prop:
     *  1. 'this' will be the ref to the leaf components (QuotationsDesktop.js, QuotationsMobile.js)
     *  2. the addEventListener function is actually registered in the leaf components (QuotationsDesktop.js, QuotationsMobile.js)
     * Deletion occurs if:
     *  1. Click occurred on any element except 
     *      .slc-data-label-info
     *      .slc-data-label-info-content__body
     *      in which case, deletion is already managed by the click handlers on those elements
     *  2. A label info popup is currently shown
     * @param {Event} evt 
     */
    onLabelInfoClickAnywhere(evt) {
        // get the target css class name
        const className = evt.target.getAttribute('class');
        // if target is any element except .slc-data-label-info and .slc-data-label-info-content__body, proceed
        if (className !== 'slc-data-label-info' && className !== 'slc-data-label-info-content__body') {
            // if any label info is shown, delete it
            if (this.labelInfoShowedNow) {
                this.labelInfoContentDelete(this.labelInfoShowedNow);
            }
        }
    }

    /**                                                                                   Gui
     * ======================================================================================
     */

    quotationEmphasizeGui(quotationType) {}

    /**
     * Handles the form emphasize/unemphasize Gui
     * When a quote is selected, the form is emphasized
     * When a quote is unselected, the form is unemphasized
     * @param {String} selectedQuotation 
     *  ['basic'|'plus']
     */
    formEmphasizeManageGui(selectedQuotation) {
        const formElement = document.querySelector('.slc-page-quotations-form');
        const mainElement = document.querySelector('.slc-page-quotations-main');
        if (selectedQuotation) {
            this.formEmphasizeGui(mainElement, formElement);
        } else {
            this.formUnemphasizeGui(mainElement, formElement);
        }
    }

    /**
     * Emphasizes the form Gui
     * 1. Shrinks the main pane from l12 to l8 width
     * 2. Shows the form pane
     * 3. Scrolls the page to the form pane
     * 4. Animates the form title as text typing
     * 5. Put focus onto the form's name text field
     * @param {HTMLElement} mainElement 
     * @param {HTMLElement} formElement 
     */
    formEmphasizeGui(mainElement, formElement) {
        // 1.
        const mainClass = mainElement.getAttribute('class').replace('l12', 'l8');
        mainElement.setAttribute('class', mainClass);
        // 2.
        const formClass = formElement.getAttribute('class').replace('hide', '');
        formElement.setAttribute('class', formClass);
        // 3.
        formElement.scrollIntoView();
        // 4.
        /* Uncomment this to enable the Form title animation (must remove the text from the Form Component title, also)
        const formTitleElement = document.querySelector('.slc-quotations-form__title');
        const formTitleAnimation = new AnimatedTyping('Inserisci i tuoi dati per ricevere un preventivo dettagliato su misura per te', {speed: 50}, function(txt, fullTxt, options) {
            formTitleElement.innerHTML = txt;
        }).animate();
        */
        // 5.
        const inputNameElement = document.querySelector('.slc-form-input-text-widget__input-nome');
        inputNameElement.focus();
    }

    /**
     * Unmphasizes the form Gui
     * Does not need any implementation so far
     * @param {HTMLElement} mainElement 
     * @param {HTMLElement} formElement 
     */
    formUnemphasizeGui(mainElement, formElement) {
        ////console.log('PageQuotations.formUnemphasizeGui()');
    }

    /**
     * Sets the selectedButtonId button to selected state
     * Deselects all the other 'scegli-...' buttons
     * 
     * Updates form validation related features:
     *  - if selected === true:
     *      - removes the gui invalid view
     *      - triggers form submit button state manager
     */
    quotationSelectorChooseButtonsGui(selectedButtonId, selected, selectedClassName) {

        document.querySelectorAll('[data-option-id^="scegli-"] .slc-button')
            .forEach(function(button) {
                let buttonId = button.parentElement.getAttribute('data-option-id');
                if (buttonId == selectedButtonId) {
                    if (selected) {
                        button.classList.add(selectedClassName);
                    } else {
                        button.classList.remove(selectedClassName);
                    }
                } else {
                    button.classList.remove(selectedClassName);
                }
            });

        if (selected) {
            const formGuiValidationElement = document.querySelector('.slc-data-scegli');
            formGuiValidationElement.classList.remove('slc-form-item-validation-error');
        }
        
    }

    /**
     * Sets the selectedCheckboxId checkbox checked state to selected
     * Deselects all the other 'scegli-...' checkboxes
     * 
     * Updates form validation related features:
     *  - if selected === true:
     *      - removes the gui invalid view
     *      - triggers form submit button state manager
     */
    quotationSelectorCheckboxesGui(selectedCheckboxId, selected) {

        document.querySelectorAll('[data-option-id^="scegli-"] .slc-checkbox')
            .forEach(function(checkbox) {
                let checkboxId = checkbox.parentElement.getAttribute('data-option-id');
                if (checkboxId == selectedCheckboxId) {
                    checkbox.checked = selected;
                } else {
                    checkbox.checked = false;
                }
            });

        if (selected) {
            const formGuiValidationElement = document.querySelector('.slc-data-scegli');
            formGuiValidationElement.classList.remove('slc-form-item-validation-error');
        }
        
    }

    /**
     * Updates the cessioneDelCredito values gui, depending on the selected quotation type
     * Hilites the selected quotation value
     * Dehilites the other quotation value
     * @param {Boolean} selected 
     * @param {String} quotationType 
     *  ['kwh5'|'kwh10']
     */
    cessioneDelCreditoValuesGui(selected, quotationType) {

        if (quotationType.indexOf('kw') !== -1) {
            quotationType = kwhToQuotationType(quotationType);
        }

        const $cessioneDelCreditoValues = document.querySelectorAll('.slc-data-totaleCessioneCredito .slc-data-value');

        // cessione del credito DOM elements don't exist
        if ($cessioneDelCreditoValues.length === 0) {
            return;
        }

        // css class affecting the HTML elements gui
        const selectedCssClassName = 'slc-data-value-selected';
        // dehiltes all the values (both basic and plus)
        $cessioneDelCreditoValues
            .forEach(function(dataValueElement) {
                dataValueElement.classList.remove(selectedCssClassName);
            });
        // hilites the selected value, if this is the case
        if (selected) {
            const dataValueElement = document.querySelector('.slc-data-totaleCessioneCredito .slc-data-value-' + quotationType);
            dataValueElement.classList.add(selectedCssClassName);
        }
        
    }

    /**                                                                                Render
     * ======================================================================================
     */

    /**
     * Returns content based on responsive state
     * At the moment behaves always as a 'desktop' state
     */
    getContent() {
        return <PageQuotationsDestkop
                    navigateBack = {this.navigateBack.bind(this)}
                    navigateToWizard={this.navigateToWizard.bind(this)}
                    mapStaticImageUrl= {this.state.mapStaticImageUrl}
                    loading={this.state.loading}
                    config={this.state.config}
                    data={this.state.data}
                    onQuoteChooseButtonClick={this.onQuoteChooseButtonClick.bind(this)}
                    onLabelInfoClickAnywhere= {this.onLabelInfoClickAnywhere} />;
        /**
        return (props.gui.responsive !== 'mobile') ?
            <PageQuotationsDestkop onSubmit={onSubmit} /> :
            <PageQuotationsMobile onSubmit={onSubmit} />;
         */
    }

    /**
     * Returns the page css class name
     * @return {String}
     *  Sample
     *      'slc-page slc-page-quotations responsive-desktop
     */
    pageClassName() {
        return pageComponentCssClass('quotations', this.props.gui.responsive);
    }

    render() {
        ////console.log('    PageQuotations.state', this.state);
        if (this.state.redirect !== false) {
            return <Redirect to={this.state.redirect} />;
        } else {
            const loading = (this.state.loading) ? <Loading label={getLabel('gui.loading')} /> : null ;
            return (
                <div className={this.pageClassName()}>
                    <div className="row slc-page-header">
                        <div className="col s12">
                            <Header />
                        </div>
                    </div>
                    {loading}
                    <div className="row slc-page-body">
                        {this.getContent()}
                    </div>
                </div>
            );
        }
    }

}

export default connect(mapStateToProps)(PageQuotations);